import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

const category = 'registry';
const pagePrefix = 'admin';

export enum Page {
  'shop' = 'shop',
  'manage' = 'manage',
  'overview' = 'overview',
  'addItemDrawer' = 'addItemDrawer',
  'giftsDrawer' = 'giftsDrawer',
  'orderDetails' = 'orderDetails',
  'orderHistory' = 'orderHistory',
  'postCheckout' = 'postCheckout',
  'track' = 'track',
}

interface RegistryCheatSheetExpandedArgs {
  targetGiftCount: number;
  currentGiftCount: number;
  page: Page;
}

export const registryGiftCountsTelemetry = createTelemetryObject({
  actions: {
    registryCheatSheetSaved: (guestCount: number, page: Page) => ({
      action: 'RegistryCheatSheetSaved',
      actionType: undefined,
      pagePrefix,
      page,
      category,
      extraInfo: {
        guestCount,
      },
    }),
    priceRangeClick: (title: string, page: Page, component: string) => ({
      action: 'ButtonInteracted',
      pagePrefix,
      page,
      category,
      extraInfo: {
        label: title,
        component,
      },
    }),
    registryCheatSheetExpanded: ({ targetGiftCount, currentGiftCount, page, ...rest }: RegistryCheatSheetExpandedArgs) => ({
      action: 'RegistryCheatSheetExpanded',
      actionType: undefined,
      pagePrefix,
      page,
      category,
      extraInfo: {
        targetGiftCount,
        currentGiftCount,
        ...rest,
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(registryGiftCountsTelemetry, { eventId: '' });

const useRegistryGiftCountsTelemetry = useTelemetry;

export { TelemetryProvider, useRegistryGiftCountsTelemetry };
